var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{staticClass:"btn-success",attrs:{"disabled":_vm.disabled},on:{"click":_vm.saveChannelConfig}},[_vm._v(" "+_vm._s(_vm.$t('save_active_channel_config'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }